<div class="pedido-shell">
  <div class="container">

  <!-- ── CABEÇALHO FIXO (page-header + título "Dados do Pedido" com o
       widget de cotação/custo) -- gruda no topo ao rolar, mesmo padrão
       (position:sticky, mesmo truque de top/margin negativos pra cobrir a
       brecha do padding-top do .content-shell) usado em .pv-header-fixo no
       Pedido de Venda. O restante do card "Dados do Pedido" (os campos do
       formulário) fica FORA daqui, rola normal -- só o cabeçalho gruda,
       igual na Venda (lá também é só page-header + abas, não o card
       inteiro de campos). ── -->
  <div class="pcf-header-fixo">

  <!-- ── PAGE HEADER (mesmo padrão visual da tela de Venda) ── -->
  <div class="page-header">
    <div class="page-header-icon" style="background:rgba(255,255,255,0.15); color:#fff;">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
      </svg>
    </div>
    <div style="flex:1">
      <h1>{{ modoEdicao ? 'Editar Compra #' + nunotaAtual : 'Nova Compra' }}</h1>
      <p>{{ modoEdicao ? 'Altere os dados e salve' : 'TOP ' + COD_TIP_OPER + ' — Preencha os dados e itens da compra' }}</p>
    </div>
    <div style="display: flex; gap: 10px; align-items: center;">
      <button type="button" class="btn-salvar-header" (click)="salvar()"
        [disabled]="salvando() || carregandoEdicao || !formularioValido">
        <span *ngIf="salvando()" class="pcf-spinner"></span>
        <svg *ngIf="!salvando()" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
          <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
        </svg>
        {{ salvando() ? 'Gravando...' : modoEdicao ? 'Salvar Alterações' : 'Gravar Compra' }}
      </button>

      <button type="button" class="btn-voltar-header" (click)="onVoltarClick()" title="Voltar à lista">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        Voltar
      </button>
    </div>
  </div>

  <!-- Título "Dados do Pedido" + widget de cotação/custo, num card próprio
       (sem os campos do formulário) -- fica sticky junto com o page-header. -->
  <div class="pcf-abas-principais">
    <button type="button" class="pcf-aba-principal" [class.ativa]="abaAtiva === 'dados'" (click)="mudarAba('dados')">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
      </svg>
      Dados da Compra
    </button>
    <button type="button" class="pcf-aba-principal" [class.ativa]="abaAtiva === 'itens'" (click)="mudarAba('itens')">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
        <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
        <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
      </svg>
      Itens da Compra
      <span *ngIf="itensValidos.length > 0" class="pcf-aba-badge">{{ itensValidos.length }}</span>
    </button>

      <!-- Cotação do dólar + Custo Total (Aerosys) em U$/R$ -- mesmo
           padrão visual do Pedido de Venda, calculado pela cotação
           selecionada na compra (a mais atual, por padrão). -->
      <div class="pcf-cotacao-custo-wrap" *ngIf="cotacaoValorNumerico > 0">
        <div class="pcf-custo-pill" *ngIf="itensValidos.length > 0"
             title="Total da compra, em U$ e R$ pela cotação do dia">
          <div class="pcf-custo-pill-item">
            <span class="pcf-custo-pill-label">Total</span>
            <span class="pcf-custo-pill-valor">$ {{ fmtMoeda(totalGeralUsd) }}</span>
          </div>
          <div class="pcf-custo-pill-item">
            <span class="pcf-custo-pill-label">Total Geral</span>
            <span class="pcf-custo-pill-valor">R$ {{ fmtMoeda(totalGeral) }}</span>
          </div>
        </div>

        <div class="pcf-cotacao-pill" (click)="abrirBuscaCotacao()" title="Ver/alterar a cotação do dólar da compra">
          <svg width="30" height="30" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" class="pcf-cotacao-flag-svg">
            <defs>
              <clipPath id="pcf-fc-circle"><circle cx="18" cy="18" r="17"/></clipPath>
              <clipPath id="pcf-fc-left"><rect x="0" y="0" width="18" height="36"/></clipPath>
              <clipPath id="pcf-fc-right"><rect x="18" y="0" width="18" height="36"/></clipPath>
            </defs>
            <g clip-path="url(#pcf-fc-circle)">
              <g clip-path="url(#pcf-fc-left)">
                <rect width="36" height="36" fill="#B22234"/>
                <rect y="2.77" width="36" height="2.77" fill="#FFF"/>
                <rect y="8.31" width="36" height="2.77" fill="#FFF"/>
                <rect y="13.85" width="36" height="2.77" fill="#FFF"/>
                <rect y="19.38" width="36" height="2.77" fill="#FFF"/>
                <rect y="24.92" width="36" height="2.77" fill="#FFF"/>
                <rect y="30.46" width="36" height="2.77" fill="#FFF"/>
                <rect width="10" height="15.4" fill="#3C3B6E"/>
              </g>
              <g clip-path="url(#pcf-fc-right)">
                <rect x="18" width="18" height="36" fill="#009C3B"/>
                <polygon points="18,5 33,18 18,31 3,18" fill="#FFDF00"/>
                <circle cx="18" cy="18" r="6" fill="#002776"/>
              </g>
              <line x1="18" y1="0" x2="18" y2="36" stroke="rgba(255,255,255,0.35)" stroke-width="0.7"/>
            </g>
            <circle cx="18" cy="18" r="16.5" fill="none" stroke="rgba(0,0,0,0.12)" stroke-width="1.5"/>
          </svg>
          <div class="pcf-cotacao-info">
            <span class="pcf-cotacao-label">Dólar EUA</span>
            <span class="pcf-cotacao-valor">R$ {{ cotacaoValorNumerico | number:'1.2-2':'pt-BR' }}</span>
          </div>
        </div>
      </div>
  </div>
  </div><!-- /.pcf-header-fixo -->

  <!-- ── ALERTA (mesmo padrão da tela de Venda) ── -->
  <div *ngIf="alerta" class="alerta" [ngClass]="'alerta-' + alerta.tipo">
    {{ alerta.mensagem }}
  </div>

  <!-- ── CARREGANDO EDIÇÃO ── -->
  <div *ngIf="carregandoEdicao" class="pcf-loading">
    <span class="pcf-spinner pcf-spinner-lg"></span>
    Carregando compra...
  </div>

  <ng-container *ngIf="!carregandoEdicao">

    <!-- ═══════════════════════════════════════════ CONTEÚDO ═══════════ -->
    <div class="pcf-conteudo">
      <div class="card" *ngIf="abaAtiva === 'dados'">
      <div class="form-grid">

        <!-- ── LINHA 1: FORNECEDOR + CLIENTE A SER ENTREGUE + DATAS ── -->
        <div class="pcf-top-row">

          <!-- FORNECEDOR -->
          <div class="form-group pcf-campo-fornecedor">
            <div class="pcf-fornec-titulos-linha">
              <label class="form-label pcf-label-abs required">FORNECEDOR</label>
              <span *ngFor="let t of titulosFornecedorPosicionados"
                    class="pcf-fornec-titulo-extra"
                    [style.left.px]="t.left">{{ t.label }}</span>
            </div>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="abrirModalFornecedor()" title="Buscar Fornecedor">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input type="text" class="form-input pcf-input-busca"
                placeholder="Digite CNPJ, nome ou código..."
                [(ngModel)]="fornecedorBusca"
                (input)="onFornecedorInput()"
                (focus)="onFornecedorFocus()"
                (blur)="onFornecedorBlur()"
                autocomplete="off">
              <button *ngIf="fornecedorSelecionado" class="input-clear-btn" type="button"
                (click)="removerFornecedor()" title="Remover">✕</button>
            </div>
            <!-- Dropdown -->
            <div class="pcf-dropdown" *ngIf="mostrarDropdownFornecedor">
              <div *ngIf="fornecedorCarregando" class="pcf-dropdown-loading">
                <span class="pcf-spinner pcf-spinner-sm"></span> Buscando...
              </div>
              <div *ngIf="!fornecedorCarregando && fornecedorSugestoes.length === 0" class="pcf-dropdown-vazio">
                Nenhum fornecedor encontrado
              </div>
              <button *ngFor="let f of fornecedorSugestoes" type="button"
                class="pcf-dropdown-item" (mousedown)="selecionarFornecedor(f)">
                <div class="pcf-item-nome">{{ f.nomeparc }}</div>
                <div class="pcf-item-meta">
                  {{ f.codparc }}
                  <span *ngIf="f.docparc"> · {{ fmtDocumento(f.docparc) }}</span>
                  <span *ngIf="f.inscEstadual"> · IE: {{ fmtIE(f.inscEstadual) }}</span>
                  <span *ngIf="f.cidade"> · {{ f.cidade }}/{{ f.uf }}</span>
                </div>
              </button>
            </div>
          </div>

          <!-- CLIENTE A SER ENTREGUE (CODPARC destino -- mesmo campo/conceito da "Pessoa de Entrega" da aba Transporte no Pedido de Venda) -->
          <div class="form-group pcf-campo-cliente-entrega">
            <div class="pcf-fornec-titulos-linha">
              <label class="form-label pcf-label-abs">CLIENTE A SER ENTREGUE</label>
              <span *ngFor="let t of titulosClienteEntregaPosicionados"
                    class="pcf-fornec-titulo-extra"
                    [style.left.px]="t.left">{{ t.label }}</span>
            </div>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="onClienteEntregaFocus()" title="Buscar Cliente a ser Entregue">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input type="text" class="form-input pcf-input-busca"
                placeholder="Digite CNPJ, nome ou código..."
                [(ngModel)]="clienteEntregaBusca"
                (input)="onClienteEntregaInput()"
                (focus)="onClienteEntregaFocus()"
                (blur)="onClienteEntregaBlur()"
                autocomplete="off">
              <button *ngIf="clienteEntregaSelecionado" class="input-clear-btn" type="button"
                (click)="removerClienteEntrega()" title="Remover">✕</button>
            </div>
            <!-- Dropdown -->
            <div class="pcf-dropdown" *ngIf="mostrarDropdownClienteEntrega">
              <div *ngIf="clienteEntregaCarregando" class="pcf-dropdown-loading">
                <span class="pcf-spinner pcf-spinner-sm"></span> Buscando...
              </div>
              <div *ngIf="!clienteEntregaCarregando && clienteEntregaSugestoes.length === 0" class="pcf-dropdown-vazio">
                Nenhum cliente encontrado
              </div>
              <button *ngFor="let c of clienteEntregaSugestoes" type="button"
                class="pcf-dropdown-item" (mousedown)="selecionarClienteEntrega(c)">
                <div class="pcf-item-nome">{{ c.nomeparc }}</div>
                <div class="pcf-item-meta">
                  {{ c.codparc }}
                  <span *ngIf="c.docparc"> · {{ fmtDocumento(c.docparc) }}</span>
                  <span *ngIf="c.inscEstadual"> · IE: {{ fmtIE(c.inscEstadual) }}</span>
                  <span *ngIf="c.cidade"> · {{ c.cidade }}/{{ c.uf }}</span>
                </div>
              </button>
            </div>
          </div>

          <!-- DATA DE EMISSÃO (bloqueada -- não pode ser alterada pelo usuário) -->
          <div class="form-group pcf-campo-data">
            <label class="form-label required">DATA EMISSÃO</label>
            <input type="date" class="form-input" [(ngModel)]="dataEmissao" readonly
              title="Data de emissão fixa, não editável">
          </div>

          <!-- PREVISÃO DE ENTREGA -->
          <div class="form-group pcf-campo-data">
            <label class="form-label">PREV. ENTREGA</label>
            <input type="date" class="form-input" [(ngModel)]="dtPrevent">
          </div>

        </div>

        <!-- ── LINHA 2: STATUS | CATEGORIA | TIPO (ORIGEM) | TIPO DE NEGOCIAÇÃO (CONDIÇÃO DE PAGAMENTO) | TIPO DE OPERAÇÃO ── -->
        <div class="pcf-mid-row">

          <!-- STATUS (GPL_STATUS -- espelho do status no Aerosys, só existe após salvar) -->
          <div class="form-group pcf-campo-status">
            <label class="form-label">STATUS</label>
            <div class="pcf-top-fixo" [class.pcf-top-fixo-vazio]="!gplStatusAtual">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              {{ gplStatusAtual || 'Nova compra' }}
            </div>
          </div>

          <!-- CATEGORIA (TGFCAB.AD_CATEGORIA) -- mesmo campo/domínio usado no Pedido de Venda. -->
          <div class="form-group pcf-campo-categoria">
            <label class="form-label">CATEGORIA</label>
            <select class="form-input" [(ngModel)]="adCategoria">
              <option *ngFor="let o of adCategoriaOpcoes" [value]="o.valor">{{ o.opcao }}</option>
            </select>
          </div>

          <!-- GPL_TIPO (NACIONAL / IMPORTAÇÃO) -->
          <div class="form-group pcf-campo-tipo-origem">
            <label class="form-label">TIPO (ORIGEM)</label>
            <select class="form-input" [(ngModel)]="tipoGpl" (ngModelChange)="aoMudarTipoGpl()">
              <option *ngFor="let o of tipoGplOpcoes" [value]="o.valor">{{ labelTipoGpl(o.valor) }}</option>
            </select>
          </div>

          <!-- TIPO DE NEGOCIAÇÃO -->
          <div class="form-group pcf-campo-tipneg">
            <label class="form-label">TIPO DE NEGOCIAÇÃO (CONDIÇÃO DE PAGAMENTO)</label>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="abrirBuscaTipoNegociacao()" title="Buscar Tipo">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input type="text" class="form-input"
                [value]="valorExibidoTipoNegociacao(tipoNegociacaoSelecionado)"
                (input)="onInputTipoNegociacao($event)"
                placeholder="Condição de pagamento..."
                autocomplete="off">
              <button *ngIf="tipoNegociacaoSelecionado" class="input-clear-btn" type="button"
                (click)="limparTipoNegociacao()" title="Remover">✕</button>
            </div>
          </div>

          <!-- TIPO DE OPERAÇÃO -->
          <div class="form-group pcf-campo-tipoper">
            <label class="form-label">TIPO DE OPERAÇÃO</label>
            <div class="pcf-top-fixo">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              {{ COD_TIP_OPER }} — {{ descricaoTop }} (automático pelo TIPO)
            </div>
          </div>

        </div>

        <!-- ── LINHA 3: Nº TÍTULO | Nº PO | Nº ORDEM | Nº COTAÇÃO | Nº ENTREGA | Nº RASTREAM. (todos AD_*, opcionais, espelhados no Aerosys) ── -->
        <div class="pcf-mid-row-nums">

          <!-- NÚMERO TÍTULO (AD_NUMTITULO) -->
          <div class="form-group">
            <label class="form-label">Número Título</label>
            <input type="text" class="form-input" [(ngModel)]="numTitulo" placeholder="Nº título...">
          </div>

          <!-- NÚMERO PO (AD_PONUMBER) -->
          <div class="form-group">
            <label class="form-label">Número PO</label>
            <input type="text" class="form-input" [(ngModel)]="numPo" placeholder="Nº PO...">
          </div>

          <!-- NÚMERO ORDEM (AD_NUMORDEM) -->
          <div class="form-group">
            <label class="form-label">Número Ordem</label>
            <input type="text" class="form-input" [(ngModel)]="numOrdem" placeholder="Nº ordem...">
          </div>

          <!-- NÚMERO COTAÇÃO (AD_NUMCOT) -->
          <div class="form-group">
            <label class="form-label">Número Cotação</label>
            <input type="text" class="form-input" [(ngModel)]="numCotacao" placeholder="Nº cotação...">
          </div>

          <!-- NÚMERO ENTREGA (AD_NUMENTREGA) -->
          <div class="form-group">
            <label class="form-label">Número Entrega</label>
            <input type="text" class="form-input" [(ngModel)]="numEntrega" placeholder="Nº entrega...">
          </div>

          <!-- NÚMERO RASTREAMENTO (AD_NUMRAST) -->
          <div class="form-group">
            <label class="form-label">Número Rastream.</label>
            <input type="text" class="form-input" [(ngModel)]="numRastreamento" placeholder="Nº rastream...">
          </div>

        </div>

        <!-- ── LINHA 4: COMPRADOR | NATUREZA | CENTRO DE RESULTADO | PROJETO ── -->
        <div class="pcf-mid-row-2">

          <!-- COMPRADOR -->
          <div class="form-group">
            <label class="form-label">COMPRADOR</label>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="abrirBuscaComprador()" title="Buscar Comprador">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
              </button>
              <input type="text" class="form-input"
                [value]="valorExibidoComprador(compradorSelecionado)"
                (input)="onInputComprador($event)"
                placeholder="Comprador..."
                autocomplete="off">
              <button *ngIf="compradorSelecionado" class="input-clear-btn" type="button"
                (click)="limparComprador()" title="Remover">✕</button>
            </div>
          </div>

          <!-- NATUREZA -->
          <div class="form-group">
            <label class="form-label">NATUREZA</label>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="abrirBuscaNatureza()" title="Buscar Natureza">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input type="text" class="form-input"
                [value]="valorExibidoNatureza(naturezaSelecionada)"
                (input)="onInputNatureza($event)"
                placeholder="Natureza..."
                autocomplete="off">
            </div>
          </div>

          <!-- CENTRO DE RESULTADO -->
          <div class="form-group">
            <label class="form-label">CENTRO DE RESULTADO</label>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="abrirBuscaCentroResultado()" title="Buscar Centro de Resultado">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input type="text" class="form-input"
                [value]="valorExibidoCentroResultado(centroResultadoSelecionado)"
                (input)="onInputCentroResultado($event)"
                placeholder="Centro resultado..."
                autocomplete="off">
              <button *ngIf="centroResultadoSelecionado && String(centroResultadoSelecionado) !== '0'"
                class="input-clear-btn" type="button" (click)="limparCentroResultado()" title="Limpar">✕</button>
            </div>
          </div>

          <!-- PROJETO (padrão fixo: 1000000000 - GLOBAL PARTS IMPORTAÇÕES) -->
          <div class="form-group">
            <label class="form-label">PROJETO</label>
            <div class="input-icon-wrap">
              <button type="button" class="form-icon-btn" (click)="abrirBuscaProjeto()" title="Buscar Projeto">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input type="text" class="form-input"
                [value]="valorExibidoProjeto(projetoSelecionado)"
                (input)="onInputProjeto($event)"
                placeholder="Projeto..."
                autocomplete="off">
              <button *ngIf="projetoSelecionado && String(projetoSelecionado) !== '0'"
                class="input-clear-btn" type="button" (click)="limparProjeto()" title="Limpar">✕</button>
            </div>
          </div>

        </div>

        <!-- OBSERVAÇÃO DO COMPRADOR (TGFCAB.OBSERVACAO) + OBSERVAÇÃO INTERNA
             (TGFCAB.AD_OBSINT) -- mesma linha, mesmo padrão da Venda ── -->
        <div class="form-group span-2 observacao-linha">
          <div class="form-subgroup">
            <label class="form-label">Observação do Comprador</label>
            <textarea class="form-input form-textarea" rows="3" [(ngModel)]="observacao"
              placeholder="Observações da compra..."></textarea>
          </div>
          <div class="form-subgroup">
            <label class="form-label">Observação Interna</label>
            <textarea class="form-input form-textarea" rows="3" [(ngModel)]="observacaoInterna"
              placeholder="Observações internas (não impressas)..."></textarea>
          </div>
        </div>

      </div><!-- /form-grid -->
      </div><!-- /card -->

      <!-- ── ITENS DO PEDIDO ── -->
      <div class="pcf-itens-secao card" *ngIf="abaAtiva === 'itens'">
        <div class="pcf-itens-secao-titulo">
          <!-- Input oculto para seleção do arquivo Excel -->
          <input id="pcf-excel-input" type="file" accept=".xlsx,.xls" style="display:none"
            (change)="onExcelSelecionado($event)">
          <!-- Botão Excel — antes do ícone do título -->
          <button type="button" class="pcf-btn-excel" (click)="abrirSeletorExcel()"
            title="Importar itens de planilha Excel (Colunas: PN e Quantidade)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="12" y1="18" x2="12" y2="12"/>
              <line x1="9" y1="15" x2="12" y2="18"/>
              <line x1="15" y1="15" x2="12" y2="18"/>
            </svg>
          </button>
          <!-- Botão Exportar Itens -- ao lado do Importar, mesmo padrão do Pedido de Venda -->
          <button type="button" class="pcf-btn-excel pcf-btn-excel-exportar" (click)="exportarItensExcel()"
            title="Exportar itens da compra para planilha Excel">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="12" y1="12" x2="12" y2="18"/>
              <line x1="9" y1="15" x2="12" y2="12"/>
              <line x1="15" y1="15" x2="12" y2="12"/>
            </svg>
          </button>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
            <line x1="8" y1="18" x2="21" y2="18"/>
            <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/>
            <line x1="3" y1="18" x2="3.01" y2="18"/>
          </svg>
          Itens da Compra
          <span class="pcf-tab-badge" *ngIf="itensValidos.length > 0">{{ itensValidos.length }}</span>

          <!-- "Funções" -- engrenagem com menu de ações sobre os Itens da Compra -->
          <div class="pcf-funcoes-wrap" (click)="$event.stopPropagation()">
            <button type="button" class="pcf-funcoes-btn" (click)="toggleFuncoesMenu($event)"
              title="Funções" [class.pcf-funcoes-btn-ativo]="funcoesMenuAberto">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
              </svg>
            </button>
            <div class="pcf-funcoes-menu" *ngIf="funcoesMenuAberto">
              <button type="button" class="pcf-funcoes-item" (click)="abrirImportarPreCompras()">
                Importar Pré-Compras
              </button>
              <button type="button" class="pcf-funcoes-item" (click)="abrirDescobertaPecasComVenda()">
                Imp. Peças com Venda nos últimos X meses
              </button>
              <div class="pcf-funcoes-submenu-wrap">
                <div class="pcf-funcoes-item pcf-funcoes-item-submenu">
                  <span>Imp. Peças de uma seleção de Vendas</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 6 9 12 15 18"/>
                  </svg>
                </div>
                <div class="pcf-funcoes-submenu">
                  <button type="button" class="pcf-funcoes-item" (click)="abrirBuscaVendas(false)">Geral</button>
                  <button type="button" class="pcf-funcoes-item" (click)="abrirBuscaVendas(true)">Apenas Importação</button>
                </div>
              </div>
              <button type="button" class="pcf-funcoes-item" (click)="abrirBuscaFabricante()">
                Imp. Peças de um Fabricante
              </button>
            </div>
          </div>
        </div>

        <div class="pcf-itens-toolbar">
        <div class="pcf-itens-resumo" *ngIf="itensValidos.length > 0">
          <span>{{ itensValidos.length }} {{ itensValidos.length === 1 ? 'item' : 'itens' }}</span>
        </div>
      </div>

      <div class="pcf-table-wrap">
        <table class="pcf-itens-table">
          <thead>
            <tr>
              <th class="pcf-th-pn">Part Number</th>
              <th class="pcf-th-desc">DESCRIÇÃO</th>
              <th class="pcf-th-qtd">QTD</th>
              <th class="pcf-th-un">UN</th>
              <th class="pcf-th-preco" *ngIf="exibirColunasPreco">Vl. Unit. U$</th>
              <th class="pcf-th-preco" *ngIf="exibirColunasPreco">Vl. Unit. R$</th>
              <th class="pcf-th-core pcf-th-core-destaque" *ngIf="exibirColunasPreco">CORE</th>
              <th class="pcf-th-core-vlr pcf-th-core-destaque" *ngIf="exibirColunasPreco">Core Unit R$</th>
              <th class="pcf-th-core-total pcf-th-core-destaque" *ngIf="exibirColunasPreco">Total Core R$</th>
              <th class="pcf-th-desc2" *ngIf="exibirColunasPreco">DESC %</th>
              <th class="pcf-th-total" *ngIf="exibirColunasPreco">SubTotal U$</th>
              <th class="pcf-th-total" *ngIf="exibirColunasPreco">SubTotal R$</th>
              <th class="pcf-th-cod" *ngIf="exibirColunasPreco">Cód Peça</th>
              <th class="pcf-th-local">Local Sankhya</th>
              <th class="pcf-th-local-aero">Local Aerosys</th>
              <th class="pcf-th-acao"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of itens" [class.pcf-row-ok]="item.codprodInterno">
              <!-- PN -->
              <td class="pcf-td-pn">
                <div class="pcf-pn-wrap">
                  <input type="text" class="pcf-cell-pn"
                    [(ngModel)]="item.codprod"
                    placeholder="PN / F3"
                    [disabled]="!!item.buscando"
                    (keydown.enter)="abrirBuscaPecas(item, $event)"
                    (keydown.f3)="abrirBuscaPecas(item, $event)"
                    (blur)="onPnBlur(item, $event)"
                    autocomplete="off">
                  <span *ngIf="item.buscando" class="pcf-cell-spinner"></span>
                </div>
              </td>
              <!-- Descrição -->
              <td class="pcf-td-desc">
                <span *ngIf="item.descricao" class="pcf-desc-text">{{ item.descricao }}</span>
                <span *ngIf="!item.descricao" class="pcf-desc-vazio">—</span>
              </td>
              <!-- QTD -->
              <td class="pcf-td-qtd">
                <input type="number" class="pcf-cell-qtd" [(ngModel)]="item.quantidade"
                  min="0.001" step="1"
                  (ngModelChange)="onQtdChange(item)"
                  (keydown.enter)="confirmarItemCompra(item, $event)"
                  (focus)="$any($event.target).select()">
              </td>
              <!-- UN (bloqueado — vem do cadastro do produto) -->
              <td class="pcf-td-un">
                <input type="text" class="pcf-cell-un pcf-cell-readonly" [value]="item.unidade" readonly tabindex="-1">
              </td>
              <!-- Preço U$ -->
              <td class="pcf-td-preco" *ngIf="exibirColunasPreco">
                <input type="text" class="pcf-cell-preco"
                  [(ngModel)]="item.precoUsdStr"
                  placeholder="0,00"
                  (blur)="onPrecoUsdBlur(item, $event)"
                  (focus)="$any($event.target).select()"
                  autocomplete="off">
              </td>
              <!-- Preço R$ -->
              <td class="pcf-td-preco pcf-preco-brl" *ngIf="exibirColunasPreco">
                {{ item.precoUnitario > 0 ? fmtDecimal(item.precoUnitario) : '—' }}
              </td>
              <!-- CORE (Sim/Não) — igual ao Pedido de Venda -->
              <td class="pcf-td-core pcf-core-destaque" *ngIf="exibirColunasPreco">
                <span class="pcf-badge-core"
                      [class.pcf-badge-core-sim]="item.controlaCore"
                      [class.pcf-badge-core-nao]="!item.controlaCore && !(item.vlrCore > 0)"
                      [class.pcf-badge-core-nao-reativo]="!item.controlaCore && item.vlrCore > 0"
                      [class.pcf-badge-core-clicavel]="item.controlaCore || item.vlrCore > 0"
                      [title]="item.controlaCore ? 'Clique para desativar Core' : (item.vlrCore > 0 ? 'Clique para reativar Core' : 'Sem Core cadastrado')"
                      (click)="toggleCore(item)">
                  {{ item.controlaCore ? 'Sim' : 'Não' }}
                </span>
              </td>
              <!-- Core Unit R$ -->
              <td class="pcf-td-core-vlr pcf-core-destaque" *ngIf="exibirColunasPreco">
                <span *ngIf="item.controlaCore">{{ fmtDecimal(item.coreUnitBrl) }}</span>
                <span *ngIf="!item.controlaCore" class="pcf-cell-zero">0,00</span>
              </td>
              <!-- Total Core R$ -->
              <td class="pcf-td-core-total pcf-core-destaque" *ngIf="exibirColunasPreco">
                <span *ngIf="item.controlaCore && item.totalCoreBrl > 0">{{ fmtDecimal(item.totalCoreBrl) }}</span>
                <span *ngIf="!item.controlaCore || item.totalCoreBrl === 0" class="pcf-cell-zero">0,00</span>
              </td>
              <!-- Desc % -->
              <td class="pcf-td-desc2" *ngIf="exibirColunasPreco">
                <input type="number" class="pcf-cell-desc"
                  [(ngModel)]="item.desconto" min="0" max="100" step="0.01"
                  (ngModelChange)="onDescontoChange(item)"
                  (focus)="$any($event.target).select()">
              </td>
              <!-- SubTotal U$ -->
              <td class="pcf-td-total" *ngIf="exibirColunasPreco">
                <span [class.pcf-total-zero]="item.totalUsd <= 0">
                  {{ item.totalUsd > 0 ? fmtDecimal(item.totalUsd) : '—' }}
                </span>
              </td>
              <!-- SubTotal R$ -->
              <td class="pcf-td-total" *ngIf="exibirColunasPreco">
                <span [class.pcf-total-zero]="item.total <= 0">
                  {{ item.total > 0 ? fmtMoeda(item.total) : '—' }}
                </span>
              </td>
              <!-- Cód Peça -->
              <td class="pcf-td-cod" *ngIf="exibirColunasPreco">
                {{ item.codprodInterno || '—' }}
              </td>
              <!-- Local do estoque (Sankhya) -->
              <td class="pcf-td-local">
                <div class="pcf-local-wrap" *ngIf="item.codprodInterno">
                  <select class="pcf-cell-local" [(ngModel)]="item.localSel"
                    title="Local do estoque (padrão: entrada mais recente)">
                    <option *ngFor="let o of item.locaisOpcoes" [ngValue]="o.codLocal">{{ o.descrLocal }}</option>
                  </select>
                </div>
              </td>
              <!-- Local do Aerosys (informativo) -->
              <td class="pcf-td-local-aero">{{ item.localAerosys || '—' }}</td>
              <!-- Ação -->
              <td class="pcf-td-acao">
                <button type="button" class="pcf-btn-remover"
                  (click)="removerItem(item.id)" title="Remover linha">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"/>
                    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                    <path d="M10 11v6"/><path d="M14 11v6"/>
                    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
          <!-- Totais -- alinhados embaixo da própria coluna, igual ao Pedido de Venda -->
          <tfoot *ngIf="itensValidos.length > 0 && exibirColunasPreco">
            <tr class="pcf-tfoot-row">
              <!-- PN, Descrição, Qtd, UN, Vl.Unit U$, Vl.Unit R$, CORE, Core Unit R$ -->
              <td colspan="8" class="pcf-tfoot-vazio"></td>
              <!-- Total Core R$ -->
              <td class="pcf-tfoot-core pcf-core-destaque">
                <span class="pcf-tfoot-label">Total Core R$</span>
                <span class="pcf-tfoot-valor">{{ totalCoreGeral > 0 ? fmtDecimal(totalCoreGeral) : '0,00' }}</span>
              </td>
              <!-- Desc % -->
              <td class="pcf-tfoot-vazio"></td>
              <!-- SubTotal U$ -->
              <td class="pcf-tfoot-subtotal">
                <span class="pcf-tfoot-label">SubTotal U$</span>
                <span class="pcf-tfoot-valor">{{ fmtDecimal(totalGeralUsd) }}</span>
              </td>
              <!-- SubTotal R$ -->
              <td class="pcf-tfoot-subtotal">
                <span class="pcf-tfoot-label">SubTotal R$</span>
                <span class="pcf-tfoot-valor">{{ fmtMoeda(totalGeral) }}</span>
              </td>
              <!-- Cód Peça, Ação -->
              <td colspan="2" class="pcf-tfoot-vazio"></td>
            </tr>
          </tfoot>
        </table>
      </div>

        <!-- Resumo Total / Total Geral -- igual ao "Total Pedido U$/R$" do Pedido de Venda -->
        <div class="pcf-totais-resumo" *ngIf="itensValidos.length > 0">
          <div class="pcf-totais-item">
            <span class="pcf-totais-label">Total</span>
            <span class="pcf-totais-valor">$ {{ fmtDecimal(totalGeralUsd) }}</span>
          </div>
          <div class="pcf-totais-item pcf-totais-final">
            <span class="pcf-totais-label">Total Geral</span>
            <span class="pcf-totais-valor">{{ fmtMoeda(totalGeral) }}</span>
          </div>
        </div>

        <div class="pcf-hint" *ngIf="itensValidos.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Digite o PN e pressione <kbd>Enter</kbd> pra preencher direto, ou <kbd>F3</kbd> pra abrir a busca de peças.
        </div>

      </div><!-- /pcf-itens-secao -->

    </div><!-- /pcf-conteudo -->

  </ng-container>

  </div><!-- /container -->
</div><!-- /pedido-shell -->

<!-- ══════════════════════ MODAIS ══════════════════════════════════════════ -->

<!-- Modal Fornecedor (lupa) — mesmo padrão do "Procurando por Cliente" da Venda -->
<div class="modal-overlay" *ngIf="fornecedorModalAberta" (click)="fecharModalFornecedor()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Selecionar Fornecedor</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Nome, CNPJ ou código..."
        [(ngModel)]="filtroFornecedorModal"
        (ngModelChange)="onFiltroFornecedorModalChange()"
        autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="fornecedorModalCarregando" class="busca-modal-empty">
          <span class="pcf-spinner pcf-spinner-sm"></span> Buscando...
        </div>
        <button *ngFor="let f of fornecedorModalLista" type="button"
          class="busca-modal-item" (click)="selecionarFornecedorModal(f)">
          <div class="busca-item-nome">{{ f.nomeparc }}</div>
          <div class="busca-item-detalhes">
            <span>Cód. {{ f.codparc }}</span>
            <span *ngIf="f.docparc">{{ fmtDocumento(f.docparc) }}</span>
            <span *ngIf="f.inscEstadual">{{ fmtIE(f.inscEstadual) }}</span>
            <span *ngIf="f.cidade">{{ f.cidade }}/{{ f.uf }}</span>
          </div>
        </button>
        <div *ngIf="!fornecedorModalCarregando && fornecedorModalLista.length === 0" class="busca-modal-empty">
          Nenhum fornecedor encontrado.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharModalFornecedor()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Comprador -->
<div class="modal-overlay" *ngIf="compradorModalAberta" (click)="fecharBuscaComprador()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Selecionar Comprador</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Filtrar por nome..."
        [(ngModel)]="filtroComprador" autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <button *ngFor="let v of compradoresFiltrados" type="button"
          class="busca-modal-item" (click)="selecionarComprador(v)"
          [class.selecionado]="String(v.codVend) === String(compradorSelecionado)">
          <div class="busca-item-nome">{{ v.apelido }}</div>
          <div class="busca-item-meta">Cód. {{ v.codVend }}</div>
        </button>
        <div *ngIf="compradoresFiltrados.length === 0" class="busca-modal-empty">Nenhum resultado.</div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaComprador()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Tipo Negociação -->
<div class="modal-overlay" *ngIf="tipoNegociacaoModalAberta" (click)="fecharBuscaTipoNegociacao()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Condições de Pagamento Disponíveis</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Filtrar condição..."
        [(ngModel)]="filtroTipoNegociacao" autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="tiposNegociacaoCarregando" class="busca-modal-empty">
          <span class="pcf-spinner pcf-spinner-sm"></span> Carregando...
        </div>
        <button *ngFor="let t of tiposNegociacaoFiltrados" type="button"
          class="busca-modal-item" (click)="selecionarTipoNegociacao(t)"
          [class.selecionado]="String(t.codTipVenda) === String(tipoNegociacaoSelecionado)">
          <div class="busca-item-nome">{{ t.descricao }}</div>
          <div class="busca-item-meta">Cód. {{ t.codTipVenda }}</div>
        </button>
        <div *ngIf="!tiposNegociacaoCarregando && tiposNegociacaoFiltrados.length === 0" class="busca-modal-empty">
          Nenhuma condição encontrada.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaTipoNegociacao()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Natureza -->
<div class="modal-overlay" *ngIf="naturezaModalAberta" (click)="fecharBuscaNatureza()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Naturezas Disponíveis</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Filtrar natureza..."
        [(ngModel)]="filtroNatureza" autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="naturezasCarregando" class="busca-modal-empty">
          <span class="pcf-spinner pcf-spinner-sm"></span> Carregando...
        </div>
        <button *ngFor="let n of naturezasFiltradas" type="button"
          class="busca-modal-item" (click)="selecionarNatureza(n)"
          [class.selecionado]="String(n.codNat) === String(naturezaSelecionada)">
          <div class="busca-item-nome">{{ n.descricao }}</div>
          <div class="busca-item-meta">Cód. {{ n.codNat }}</div>
        </button>
        <div *ngIf="!naturezasCarregando && naturezasFiltradas.length === 0" class="busca-modal-empty">
          Nenhuma natureza encontrada.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaNatureza()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Centro de Resultado -->
<div class="modal-overlay" *ngIf="centroResultadoModalAberta" (click)="fecharBuscaCentroResultado()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Centros de Resultado Disponíveis</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Filtrar centro de resultado..."
        [(ngModel)]="filtroCentroResultado" autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="centrosResultadoCarregando" class="busca-modal-empty">
          <span class="pcf-spinner pcf-spinner-sm"></span> Carregando...
        </div>
        <button *ngFor="let c of centrosResultadoFiltrados" type="button"
          class="busca-modal-item" (click)="selecionarCentroResultado(c)"
          [class.selecionado]="String(c.codCen) === String(centroResultadoSelecionado)">
          <div class="busca-item-nome">{{ c.descricao }}</div>
          <div class="busca-item-meta">Cód. {{ c.codCen }}</div>
        </button>
        <div *ngIf="!centrosResultadoCarregando && centrosResultadoFiltrados.length === 0" class="busca-modal-empty">
          Nenhum centro de resultado encontrado.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaCentroResultado()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Projeto -->
<div class="modal-overlay" *ngIf="projetoModalAberta" (click)="fecharBuscaProjeto()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Projetos Disponíveis</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Filtrar projeto..."
        [(ngModel)]="filtroProjeto" autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="projetosCarregando" class="busca-modal-empty">
          <span class="pcf-spinner pcf-spinner-sm"></span> Carregando...
        </div>
        <button *ngFor="let p of projetosFiltrados" type="button"
          class="busca-modal-item" (click)="selecionarProjeto(p)"
          [class.selecionado]="String(p.codProj) === String(projetoSelecionado)">
          <div class="busca-item-nome">{{ p.descricao }}</div>
          <div class="busca-item-meta">Cód. {{ p.codProj }}</div>
        </button>
        <div *ngIf="!projetosCarregando && projetosFiltrados.length === 0" class="busca-modal-empty">
          Nenhum projeto encontrado.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaProjeto()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Cotação -->
<div class="modal-overlay" *ngIf="cotacaoModalAberta" (click)="fecharBuscaCotacao()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">Cotações Disponíveis</div>
    <div class="modal-body">
      <input type="text" class="busca-modal-input" placeholder="Filtrar por valor ou data..."
        [(ngModel)]="filtroCotacao" autocomplete="off" autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="cotacaoCarregando" class="busca-modal-empty">
          <span class="pcf-spinner pcf-spinner-sm"></span> Carregando...
        </div>
        <button *ngFor="let c of cotacoesFiltradas" type="button"
          class="busca-modal-item" (click)="selecionarCotacao(c)"
          [class.selecionado]="cotacaoSelecionada === c">
          <div class="busca-item-nome">U$ {{ c.valor }}</div>
          <div class="busca-item-meta" *ngIf="c.data || c.DATA_BR || c.DATA">
            {{ c.data ?? c.DATA_BR ?? c.DATA }}
          </div>
        </button>
        <div *ngIf="!cotacaoCarregando && cotacoesFiltradas.length === 0" class="busca-modal-empty">
          Nenhuma cotação disponível.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaCotacao()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal Importação Excel -->
<div class="pcf-modal-overlay" *ngIf="excelImportAberto" (click)="fecharImportacaoExcel()">
  <div class="pcf-modal pcf-excel-box" (click)="$event.stopPropagation()">

    <!-- Cabeçalho -->
    <div class="pcf-modal-header pcf-excel-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="12" y1="18" x2="12" y2="12"/>
        <line x1="9" y1="15" x2="12" y2="18"/><line x1="15" y1="15" x2="12" y2="18"/>
      </svg>
      Importar Itens do Excel
      <span class="pcf-excel-filename" *ngIf="excelImportNomeArquivo">— {{ excelImportNomeArquivo }}</span>
    </div>

    <!-- Loading -->
    <div class="pcf-excel-loading" *ngIf="excelImportValidando">
      <div class="pcf-spinner-sm"></div>
      {{ excelMapeamentoAberto ? 'Lendo arquivo...' : 'Validando PNs no sistema...' }}
    </div>

    <!-- Mapeamento manual de colunas -->
    <div class="pcf-excel-mapeamento" *ngIf="excelMapeamentoAberto && !excelImportValidando">
      <div class="pcf-excel-map-aviso">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        Não foi possível identificar as colunas automaticamente.
        Indique quais colunas correspondem ao <strong>PN</strong> e à <strong>Quantidade</strong>.
      </div>
      <div class="pcf-excel-map-selects">
        <div class="pcf-excel-map-campo">
          <label class="pcf-excel-map-label">Coluna de PN (Part Number)</label>
          <select class="pcf-excel-map-select" [(ngModel)]="excelColunaPn">
            <option [ngValue]="null">— Selecionar coluna —</option>
            <option *ngFor="let col of excelColunas; let i = index" [ngValue]="i">{{ col }}</option>
          </select>
        </div>
        <div class="pcf-excel-map-campo">
          <label class="pcf-excel-map-label">Coluna de Quantidade</label>
          <select class="pcf-excel-map-select" [(ngModel)]="excelColunaQty">
            <option [ngValue]="null">— Selecionar coluna —</option>
            <option *ngFor="let col of excelColunas; let i = index" [ngValue]="i">{{ col }}</option>
          </select>
        </div>
      </div>
      <div class="pcf-excel-map-preview-wrap" *ngIf="excelPreviewLinhas.length > 0">
        <p class="pcf-excel-map-preview-label">Prévia das primeiras linhas do arquivo:</p>
        <div class="pcf-excel-map-table-scroll">
          <table class="pcf-excel-map-table">
            <thead>
              <tr>
                <th *ngFor="let col of excelColunas; let i = index"
                  [class.col-marcada-pn]="excelColunaPn === i"
                  [class.col-marcada-qty]="excelColunaQty === i">
                  {{ col }}
                  <span class="col-badge pn" *ngIf="excelColunaPn === i">PN</span>
                  <span class="col-badge qty" *ngIf="excelColunaQty === i">QTD</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of excelPreviewLinhas">
                <td *ngFor="let col of excelColunas; let i = index"
                  [class.col-marcada-pn]="excelColunaPn === i"
                  [class.col-marcada-qty]="excelColunaQty === i">{{ row[i] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Resumo -->
    <div class="pcf-excel-resumo" *ngIf="!excelImportValidando && !excelMapeamentoAberto && excelImportLinhas.length > 0">
      <span class="resumo-total">{{ excelImportLinhas.length }} PNs lidos</span>
      <span class="resumo-ok">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ excelImportEncontrados }} encontrados
      </span>
      <span class="resumo-erro" *ngIf="excelImportNaoEncontrados > 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
        {{ excelImportNaoEncontrados }} não encontrados
      </span>
    </div>

    <!-- Tabela de preview -->
    <div class="pcf-excel-table-wrap" *ngIf="!excelImportValidando && !excelMapeamentoAberto">
      <table class="pcf-excel-table">
        <thead>
          <tr>
            <th class="col-status"></th>
            <th class="col-pn-excel">PN</th>
            <th class="col-desc-excel">Descrição</th>
            <th class="col-qty-excel">Qtd</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let linha of excelImportLinhas">
            <tr [class.excel-row-ok]="linha.status === 'encontrado'"
                [class.excel-row-err]="linha.status === 'nao_encontrado'">
              <td class="col-status">
                <svg *ngIf="linha.status === 'encontrado'" xmlns="http://www.w3.org/2000/svg"
                  width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                <svg *ngIf="linha.status === 'nao_encontrado'" xmlns="http://www.w3.org/2000/svg"
                  width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </td>
              <td class="col-pn-excel">{{ linha.pn }}</td>
              <td class="col-desc-excel">
                <span *ngIf="linha.status === 'encontrado'">{{ linha.descricao }}</span>
                <span *ngIf="linha.status === 'nao_encontrado'" class="excel-nao-cadastrado">
                  Não cadastrado
                  <button *ngIf="linha.proximosData && linha.proximosData.length > 0"
                    type="button" class="btn-ver-similares"
                    [class.ativo]="excelAproximadosLinha === linha"
                    (click)="toggleAproximados(linha)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                    Ver similares ({{ linha.proximosData.length }})
                  </button>
                </span>
              </td>
              <td class="col-qty-excel">{{ linha.quantidade }}</td>
            </tr>
            <tr *ngIf="excelAproximadosLinha === linha && linha.proximosData && linha.proximosData.length > 0"
                class="excel-row-similares">
              <td colspan="4" class="similares-cell">
                <div class="similares-header">Produtos similares — clique em um para usar no lugar de <strong>{{ linha.pn }}</strong>:</div>
                <div class="similares-table">
                  <div class="similares-thead">
                    <span class="sth-pn">PN</span>
                    <span class="sth-desc">Descrição</span>
                    <span class="sth-cd">CD</span>
                    <span class="sth-fab">Fabricante</span>
                  </div>
                  <button *ngFor="let p of linha.proximosData" type="button"
                    class="similar-row" (click)="selecionarAproximado(linha, p)">
                    <span class="similar-refforn">{{ p.refforn }}</span>
                    <span class="similar-desc">{{ p.descricao ?? p.descrprod }}</span>
                    <span class="similar-cd">{{ p.condicao || '—' }}</span>
                    <span class="similar-fab">{{ p.marca || '—' }}</span>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Rodapé: mapeamento -->
    <div class="pcf-modal-footer pcf-excel-footer" *ngIf="excelMapeamentoAberto && !excelImportValidando">
      <button type="button" class="pcf-modal-btn" (click)="fecharImportacaoExcel()">Cancelar</button>
      <button type="button" class="pcf-modal-btn-primary"
        [disabled]="excelColunaPn === null || excelColunaQty === null || excelColunaPn === excelColunaQty"
        (click)="confirmarMapeamento()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        Confirmar e validar PNs
      </button>
    </div>

    <!-- Rodapé: importação normal -->
    <div class="pcf-modal-footer pcf-excel-footer" *ngIf="!excelMapeamentoAberto">
      <button type="button" class="pcf-modal-btn" (click)="fecharImportacaoExcel()">Cancelar</button>
      <button type="button" class="pcf-modal-btn-primary"
        [disabled]="excelImportValidando || excelImportando || excelImportEncontrados === 0"
        (click)="confirmarImportacaoExcel()">
        <div *ngIf="excelImportando" class="pcf-spinner-sm"></div>
        <svg *ngIf="!excelImportando" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ excelImportando ? 'Importando...' : 'Importar ' + excelImportEncontrados + (excelImportEncontrados === 1 ? ' item' : ' itens') }}
      </button>
    </div>

    <!-- Confirmação: itens não encontrados -->
    <div class="pcf-excel-confirm-overlay" *ngIf="excelAvisoNaoEncontrado" (click)="cancelarAvisoExcel()">
      <div class="pcf-excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="pcf-excel-confirm-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h3 class="pcf-excel-confirm-titulo">Itens não encontrados</h3>
        <p class="pcf-excel-confirm-msg">
          <strong>{{ excelImportNaoEncontrados }} {{ excelImportNaoEncontrados === 1 ? 'item' : 'itens' }}</strong>
          não {{ excelImportNaoEncontrados === 1 ? 'foi encontrado' : 'foram encontrados' }} no sistema
          e não {{ excelImportNaoEncontrados === 1 ? 'será adicionado' : 'serão adicionados' }} à lista de itens.<br><br>
          Deseja continuar e importar apenas
          {{ excelImportEncontrados === 1 ? 'o 1 item encontrado' : 'os ' + excelImportEncontrados + ' itens encontrados' }}?
        </p>
        <div class="pcf-excel-confirm-footer">
          <button type="button" class="pcf-modal-btn" (click)="cancelarAvisoExcel()">Não, voltar</button>
          <button type="button" class="pcf-modal-btn-primary" (click)="confirmarImportacaoExcel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Sim, importar {{ excelImportEncontrados }} {{ excelImportEncontrados === 1 ? 'item' : 'itens' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal "Funções > Imp. Peças com Venda nos últimos X meses" -->
<div class="modal-overlay" *ngIf="descobertaAberta" (click)="fecharDescoberta()">
  <div class="modal-box descoberta-box" [class.pc-itens-box]="descobertaOrigem === 'pedidos'" (click)="$event.stopPropagation()">

    <div class="modal-header descoberta-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 11 12 14 22 4"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
      </svg>
      {{ descobertaOrigem === 'pedidos' ? 'Itens das Pré-Compras Selecionadas'
        : descobertaOrigem === 'vendas' ? 'Itens das Vendas Selecionadas'
        : (descobertaOrigem === 'fabricante' ? 'Peças do Fabricante' : 'Imp. Peças com Venda nos últimos X meses') }}
      <span class="pcf-excel-filename">
        — {{ (descobertaOrigem === 'vendas' || descobertaOrigem === 'fabricante' || descobertaOrigem === 'pedidos') ? descobertaOrigemDetalhe : (qtdeVendidaDtDe + ' até ' + qtdeVendidaDtAte) }}
      </span>
    </div>

    <!-- Loading -->
    <div class="pcf-excel-loading" *ngIf="descobertaCarregando">
      <div class="pcf-spinner-sm"></div>
      Buscando peças com venda no período (Aerosys + Sankhya)...
    </div>

    <!-- Sem resultado / erro -->
    <div class="pcf-excel-map-aviso" *ngIf="!descobertaCarregando && descobertaErro">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ descobertaErro }}
    </div>

    <!-- Resumo + marcar/desmarcar todos -->
    <div class="pcf-excel-resumo" *ngIf="!descobertaCarregando && descobertaItens.length > 0">
      <span class="resumo-total">
        {{ descobertaItens.length }} {{ descobertaItens.length === 1 ? 'peça' : 'peças' }}
        {{ descobertaOrigem === 'pedidos' ? 'nas pré-compras selecionadas' : descobertaOrigem === 'vendas' ? 'nas vendas selecionadas' : (descobertaOrigem === 'fabricante' ? 'do fabricante' : 'com venda no período') }}
      </span>
      <span class="resumo-ok">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ descobertaMarcadosCount }} marcadas
      </span>
      <button type="button" class="pcf-descoberta-toggle-todos" (click)="toggleDescobertaTodos()">
        {{ descobertaTodosMarcados ? 'Desmarcar todas' : 'Marcar todas' }}
      </button>
    </div>

    <!-- Tabela checklist -->
    <div class="pcf-excel-table-wrap" *ngIf="!descobertaCarregando && descobertaItens.length > 0">
      <table class="pcf-excel-table">
        <thead>
          <tr>
            <th class="col-status"></th>
            <th class="col-pn-excel">PN</th>
            <th class="col-desc-excel">Descrição</th>
            <th class="col-pn-excel" title="Condição da peça (Aerosys/Sankhya)">CD</th>
            <th class="col-qty-excel" *ngIf="descobertaOrigem !== 'fabricante' && descobertaOrigem !== 'pedidos'">Qtde Vendida</th>
            <ng-container *ngIf="descobertaOrigem === 'pedidos'">
              <th class="col-qty-excel">Qtde</th>
              <th class="col-qty-excel">Custo (R$)</th>
              <th class="col-qty-excel">Total (R$)</th>
              <th>Status</th>
              <th>Nº Pré-Compra</th>
              <th>Origem</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let linha of descobertaItens" class="excel-row-ok" (click)="linha.marcado = !linha.marcado">
            <td class="col-status">
              <input type="checkbox" [(ngModel)]="linha.marcado" (click)="$event.stopPropagation()">
            </td>
            <td class="col-pn-excel">{{ linha.pn }}</td>
            <td class="col-desc-excel">{{ linha.descricao }}</td>
            <td class="col-pn-excel">{{ linha.cd || '—' }}</td>
            <td class="col-qty-excel" *ngIf="descobertaOrigem !== 'fabricante' && descobertaOrigem !== 'pedidos'">{{ linha.qtdeVendas }}</td>
            <ng-container *ngIf="descobertaOrigem === 'pedidos'">
              <td class="col-qty-excel">{{ linha.qtdeOrigem }}</td>
              <td class="col-qty-excel">{{ linha.custoPedidoBrl ? (linha.custoPedidoBrl | number:'1.2-2') : '—' }}</td>
              <td class="col-qty-excel">{{ totalItemPedido(linha) !== null ? (totalItemPedido(linha) | number:'1.2-2') : '—' }}</td>
              <td><span class="pc-it-st">{{ linha.statusItem || '—' }}</span></td>
              <td>{{ linha.numTituloPedido || linha.headerIdOrigem || '—' }}</td>
              <td>{{ linha.origemItem === 'SANKHYA' ? 'Sankhya' : 'Aerosys' }}</td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Rodapé -->
    <div class="modal-footer" *ngIf="!descobertaCarregando">
      <button type="button" class="modal-btn" *ngIf="descobertaOrigem === 'pedidos'" [disabled]="descobertaImportando" (click)="voltarParaListaPreCompras()">Voltar</button>
      <button type="button" class="modal-btn" [disabled]="descobertaImportando" (click)="fecharDescoberta()">Cancelar</button>
      <button type="button" class="modal-btn-primary"
        [disabled]="descobertaImportando || descobertaMarcadosCount === 0"
        (click)="confirmarDescoberta()">
        <div *ngIf="descobertaImportando" class="pcf-spinner-sm"></div>
        <svg *ngIf="!descobertaImportando" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ descobertaImportando
          ? 'Importando... ' + descobertaProgressoFeito + '/' + descobertaProgressoTotal
          : 'Importar ' + descobertaMarcadosCount + (descobertaMarcadosCount === 1 ? ' item' : ' itens') }}
      </button>
    </div>
  </div>
</div>

<!-- Modal "Funções > Imp. Peças de uma seleção de Vendas" (Geral / Apenas Importação) -->
<div class="modal-overlay" *ngIf="buscaVendasAberta" (click)="fecharBuscaVendas()">
  <div class="modal-box descoberta-box" (click)="$event.stopPropagation()">

    <div class="modal-header descoberta-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
      </svg>
      Buscar Vendas
      <span class="pcf-excel-filename">— {{ buscaVendasApenasImportacao ? 'Apenas Importação' : 'Geral' }}</span>
    </div>

    <div class="pcf-busca-vendas-campo">
      <input type="text" id="pcf-busca-vendas-input" class="busca-modal-input"
        [(ngModel)]="buscaVendasTermo"
        placeholder="Nome do cliente, NUNOTA ou N° do título..."
        (keydown.enter)="buscarVendas()"
        autocomplete="off">
      <button type="button" class="modal-btn-primary" [disabled]="buscaVendasCarregando" (click)="buscarVendas()">
        <div *ngIf="buscaVendasCarregando" class="pcf-spinner-sm"></div>
        <svg *ngIf="!buscaVendasCarregando" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        Buscar
      </button>
    </div>

    <div class="pcf-excel-map-aviso" *ngIf="!buscaVendasCarregando && buscaVendasErro">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ buscaVendasErro }}
    </div>

    <div class="pcf-excel-table-wrap" *ngIf="!buscaVendasCarregando && buscaVendasResultados.length > 0">
      <table class="pcf-excel-table">
        <thead>
          <tr>
            <th class="col-status"></th>
            <th class="col-pn-excel th-ordenavel" (click)="ordenarBuscaVendas('sistema')">Sistema <span class="th-seta" [class.th-seta-ativa]="buscaVendasOrdenarCampo==='sistema'">{{ buscaVendasOrdenarCampo==='sistema' ? (buscaVendasOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-pn-excel th-ordenavel" (click)="ordenarBuscaVendas('numero')">Número <span class="th-seta" [class.th-seta-ativa]="buscaVendasOrdenarCampo==='numero'">{{ buscaVendasOrdenarCampo==='numero' ? (buscaVendasOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-pn-excel th-ordenavel" (click)="ordenarBuscaVendas('status')">Status <span class="th-seta" [class.th-seta-ativa]="buscaVendasOrdenarCampo==='status'">{{ buscaVendasOrdenarCampo==='status' ? (buscaVendasOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-desc-excel th-ordenavel" (click)="ordenarBuscaVendas('cliente')">Cliente <span class="th-seta" [class.th-seta-ativa]="buscaVendasOrdenarCampo==='cliente'">{{ buscaVendasOrdenarCampo==='cliente' ? (buscaVendasOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-qty-excel th-ordenavel" (click)="ordenarBuscaVendas('data')">Data <span class="th-seta" [class.th-seta-ativa]="buscaVendasOrdenarCampo==='data'">{{ buscaVendasOrdenarCampo==='data' ? (buscaVendasOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-qty-excel th-ordenavel" (click)="ordenarBuscaVendas('tipo')">Tipo <span class="th-seta" [class.th-seta-ativa]="buscaVendasOrdenarCampo==='tipo'">{{ buscaVendasOrdenarCampo==='tipo' ? (buscaVendasOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let v of buscaVendasResultados" class="excel-row-ok" (click)="v.marcado = !v.marcado">
            <td class="col-status">
              <input type="checkbox" [(ngModel)]="v.marcado" (click)="$event.stopPropagation()">
            </td>
            <td class="col-pn-excel">{{ v.sistema === 'sankhya' ? 'Sankhya' : 'Aerosys' }}</td>
            <td class="col-pn-excel">{{ v.numero }}</td>
            <td class="col-pn-excel"><span class="st-leg-chip" [ngClass]="statusLegadoClass(v.status)">{{ v.status }}</span></td>
            <td class="col-desc-excel">{{ v.cliente }}</td>
            <td class="col-qty-excel">{{ v.data }}</td>
            <td class="col-qty-excel">{{ v.tipo }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer">
      <button type="button" class="modal-btn" [disabled]="buscaVendasCarregando" (click)="fecharBuscaVendas()">Cancelar</button>
      <button type="button" class="modal-btn-primary"
        [disabled]="buscaVendasCarregando || buscaVendasMarcadosCount === 0"
        (click)="confirmarSelecaoVendas()">
        <div *ngIf="buscaVendasCarregando" class="pcf-spinner-sm"></div>
        <svg *ngIf="!buscaVendasCarregando" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        Ver itens ({{ buscaVendasMarcadosCount }} {{ buscaVendasMarcadosCount === 1 ? 'venda' : 'vendas' }})
      </button>
    </div>
  </div>
</div>

<!-- Modal "Funções > Importar Pré-Compras" (AUTORIZADO / BACKORDERS; Sankhya TOP 1301/1303 + Aerosys). -->
<div class="modal-overlay" *ngIf="preComprasAberta" (click)="fecharImportarPreCompras()">
  <div class="modal-box descoberta-box pc-importar-box" (click)="$event.stopPropagation()">

    <div class="modal-header descoberta-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
        <rect x="8" y="2" width="8" height="4" rx="1"/>
      </svg>
      Importar Pré-Compras
      <span class="pcf-excel-filename" *ngIf="!preComprasCarregando">— {{ preComprasListaFiltrada.length }} de {{ preComprasLista.length }}</span>
    </div>

    <div class="pcf-busca-vendas-campo">
      <input type="text" class="busca-modal-input"
        [(ngModel)]="preComprasTermo"
        placeholder="Filtrar por fornecedor, NUNOTA ou ID Aerosys (somente AUTORIZADO / BACKORDERS)..."
        autocomplete="off">
    </div>

    <div class="pcf-excel-map-aviso" *ngIf="!preComprasCarregando && preComprasErro">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ preComprasErro }}
    </div>

    <div class="busca-modal-empty" *ngIf="preComprasCarregando">Carregando Pré-Compras...</div>

    <div class="pcf-excel-table-wrap" *ngIf="!preComprasCarregando && preComprasListaFiltrada.length > 0">
      <table class="pcf-excel-table pc-imp-table">
        <thead>
          <tr>
            <th class="col-status"></th>
            <th>Código</th>
            <th>Status</th>
            <th>Nº Título</th>
            <th>Prioridade</th>
            <th class="pc-imp-c">Empresa</th>
            <th>Tipo</th>
            <th>Solicitação</th>
            <th>Solicitante</th>
            <th class="pc-imp-desc">Descrição</th>
            <th>Sistema</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of preComprasListaFiltrada" class="excel-row-ok" (click)="p.marcado = !p.marcado">
            <td class="col-status">
              <input type="checkbox" [(ngModel)]="p.marcado" (click)="$event.stopPropagation()">
            </td>
            <td [title]="p.label"><strong>{{ p.nunotaSankhya != null && p.pcpIdAerosys != null ? p.nunotaSankhya + ' / ' + p.pcpIdAerosys : (p.nunotaSankhya ?? p.pcpIdAerosys) }}</strong></td>
            <td>
              <span class="pc-st-chip" [class.pc-st-autorizado]="(p.status || '').toUpperCase() === 'AUTORIZADO'"
                    [class.pc-st-parcial]="(p.status || '').toUpperCase() === 'BACKORDERS'">{{ p.status }}</span>
            </td>
            <td>{{ p.numTitulo || '—' }}</td>
            <td>{{ p.prioridade || '—' }}</td>
            <td class="pc-imp-c">{{ p.codEmp || '—' }}</td>
            <td><span class="pc-tipo-chip" [class.pc-tipo-nacional]="(p.tipo || '').toUpperCase() === 'NACIONAL'">{{ p.tipo || '—' }}</span></td>
            <td>{{ formatarDataPedidoCompra(p.dataEmissao) }}</td>
            <td [title]="p.solicitante">{{ p.solicitante || '—' }}</td>
            <td class="pc-imp-desc" [title]="p.descricao">{{ p.descricao || '—' }}</td>
            <td>
              <span class="pc-sistema-chip"
                    [class.pc-sistema-sankhya]="p.nunotaSankhya != null && p.pcpIdAerosys == null"
                    [class.pc-sistema-aerosys]="p.nunotaSankhya == null"
                    [class.pc-sistema-ambos]="p.nunotaSankhya != null && p.pcpIdAerosys != null">
                {{ p.nunotaSankhya != null && p.pcpIdAerosys != null ? 'Sankhya + Aerosys' : (p.nunotaSankhya != null ? 'Sankhya' : 'Aerosys') }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer">
      <button type="button" class="modal-btn" [disabled]="preComprasCarregando" (click)="fecharImportarPreCompras()">Cancelar</button>
      <button type="button" class="modal-btn-primary"
        [disabled]="preComprasCarregando || preComprasMarcadosCount === 0"
        (click)="confirmarSelecaoPreCompras()">
        <div *ngIf="preComprasCarregando" class="pcf-spinner-sm"></div>
        <svg *ngIf="!preComprasCarregando" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        Ver itens ({{ preComprasMarcadosCount }} {{ preComprasMarcadosCount === 1 ? 'pré-compra' : 'pré-compras' }})
      </button>
    </div>
  </div>
</div>

<!-- Modal "Funções > Imp. Peças de um Fabricante" -- lista os fabricantes
     combinados (Sankhya TGFMAR + Aerosys FABRICANTE); clicar numa linha
     carrega as peças desse fabricante e abre o checklist de importação
     (mesmo reaproveitado por "Imp. Peças com Venda" e "Vendas"). -->
<div class="modal-overlay" *ngIf="buscaFabricanteAberta" (click)="fecharBuscaFabricante()">
  <div class="modal-box descoberta-box" (click)="$event.stopPropagation()">

    <div class="modal-header descoberta-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
      Fabricantes
      <span class="pcf-excel-filename" *ngIf="!buscaFabricanteCarregando">— {{ buscaFabricanteListaFiltrada.length }} de {{ buscaFabricanteLista.length }}</span>
    </div>

    <div class="pcf-busca-vendas-campo">
      <input type="text" id="pcf-busca-fabricante-input" class="busca-modal-input"
        [(ngModel)]="buscaFabricanteTermo"
        placeholder="Filtrar por nome ou código..."
        autocomplete="off">
    </div>

    <div class="pcf-excel-map-aviso" *ngIf="!buscaFabricanteCarregando && buscaFabricanteErro">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      {{ buscaFabricanteErro }}
    </div>

    <div class="busca-modal-empty" *ngIf="buscaFabricanteCarregando">Carregando fabricantes...</div>

    <div class="busca-modal-empty" *ngIf="!buscaFabricanteCarregando && buscaFabricanteCarregandoItens">
      <div class="pcf-spinner-sm" style="display:inline-block; vertical-align:middle; margin-right:6px;"></div>
      Carregando peças do fabricante...
    </div>

    <div class="pcf-excel-table-wrap" *ngIf="!buscaFabricanteCarregando && !buscaFabricanteCarregandoItens && buscaFabricanteListaFiltrada.length > 0">
      <table class="pcf-excel-table">
        <thead>
          <tr>
            <th class="col-pn-excel th-ordenavel" (click)="ordenarBuscaFabricante('codigo')">Código <span class="th-seta" [class.th-seta-ativa]="buscaFabricanteOrdenarCampo==='codigo'">{{ buscaFabricanteOrdenarCampo==='codigo' ? (buscaFabricanteOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-desc-excel th-ordenavel" (click)="ordenarBuscaFabricante('nome')">Nome <span class="th-seta" [class.th-seta-ativa]="buscaFabricanteOrdenarCampo==='nome'">{{ buscaFabricanteOrdenarCampo==='nome' ? (buscaFabricanteOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
            <th class="col-pn-excel th-ordenavel" (click)="ordenarBuscaFabricante('sistemas')">Sistemas <span class="th-seta" [class.th-seta-ativa]="buscaFabricanteOrdenarCampo==='sistemas'">{{ buscaFabricanteOrdenarCampo==='sistemas' ? (buscaFabricanteOrdemAsc ? '▲' : '▼') : '⇅' }}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of buscaFabricanteListaFiltrada" class="excel-row-ok"
            title="Clique para ver as peças desse fabricante" (click)="selecionarFabricante(f)">
            <td class="col-pn-excel">{{ f.codigo }}</td>
            <td class="col-desc-excel">{{ f.nome }}</td>
            <td class="col-pn-excel">
              {{ f.sankhya && f.aerosys ? 'Sankhya + Aerosys' : (f.sankhya ? 'Só Sankhya' : 'Só Aerosys') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="busca-modal-empty" *ngIf="!buscaFabricanteCarregando && !buscaFabricanteCarregandoItens && !buscaFabricanteErro && buscaFabricanteListaFiltrada.length === 0">
      Nenhum fabricante encontrado.
    </div>

    <div class="modal-footer">
      <button type="button" class="modal-btn" (click)="fecharBuscaFabricante()">Fechar</button>
    </div>
  </div>
</div>

<!-- Modal Busca de Peças (F3 / Enter no PN) -->
<div class="pcf-modal-overlay pcf-busca-pecas-modal" *ngIf="buscaPecasAberta"
  (keydown.escape)="fecharBuscaPecas()">
  <div class="pcf-modal pcf-modal-pecas" (click)="$event.stopPropagation()">
    <div class="pcf-modal-header">
      <span class="pcf-modal-titulo">Busca de Peças</span>
      <button type="button" class="pcf-modal-close" (click)="fecharBuscaPecas()">✕</button>
    </div>
    <div class="pcf-modal-body">
      <!-- Campo de busca -->
      <div class="busca-pecas-campo-unico">
        <svg class="busca-pecas-icone" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" class="busca-pecas-input-unico"
          [(ngModel)]="buscaPecasTermo"
          (ngModelChange)="onBuscaPecasInput()"
          placeholder="Digite o PN (ex: 010-11654) ou descrição (ex: ACUMULADOR GPS)..."
          autocomplete="off">
        <app-loading-indicator *ngIf="buscaPecasCarregando" size="inline"></app-loading-indicator>
      </div>
      <div class="busca-pecas-dica">Busca por PN ou descrição · Mínimo 2 caracteres</div>

      <!-- Sem resultado -->
      <div *ngIf="buscaPecasSemResultado && !buscaPecasCarregando" class="busca-modal-empty">
        Nenhuma peça encontrada.
      </div>

      <!-- Tabela de resultados — mesma estrutura da Venda (filtro/ordenação por
           coluna + sub-lista de Produtos Alternativos), sem as colunas de preço/IPI
           (Compra não trabalha com valor de venda). -->
      <div *ngIf="buscaPecasResultados.length > 0" class="busca-pecas-lista">
        <table class="busca-pecas-tabela">
          <thead>
            <tr>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'pn'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('pn')" (click)="toggleFiltroBusca('pn', $event)" [title]="temFiltroBusca('pn') ? ('Filtro: ' + filtrosBusca['pn']) : 'Clique para filtrar'">PN</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='pn'" (click)="ordenarBuscaPecas('pn')">{{ buscaPecasOrdenarCampo==='pn' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('pn')" class="th-filtro-limpar" (click)="limparFiltroBusca('pn', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'pn'" id="filtro-busca-compra-pn" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['pn']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('pn'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'cd'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('cd')" (click)="toggleFiltroBusca('cd', $event)" [title]="temFiltroBusca('cd') ? ('Filtro: ' + filtrosBusca['cd']) : 'Clique para filtrar'">CD</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='cd'" (click)="ordenarBuscaPecas('cd')">{{ buscaPecasOrdenarCampo==='cd' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('cd')" class="th-filtro-limpar" (click)="limparFiltroBusca('cd', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'cd'" id="filtro-busca-compra-cd" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['cd']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('cd'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'descricao'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('descricao')" (click)="toggleFiltroBusca('descricao', $event)" [title]="temFiltroBusca('descricao') ? ('Filtro: ' + filtrosBusca['descricao']) : 'Clique para filtrar'">Descrição</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='descricao'" (click)="ordenarBuscaPecas('descricao')">{{ buscaPecasOrdenarCampo==='descricao' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('descricao')" class="th-filtro-limpar" (click)="limparFiltroBusca('descricao', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'descricao'" id="filtro-busca-compra-descricao" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['descricao']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('descricao'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'un'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('un')" (click)="toggleFiltroBusca('un', $event)" [title]="temFiltroBusca('un') ? ('Filtro: ' + filtrosBusca['un']) : 'Clique para filtrar'">UN</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='un'" (click)="ordenarBuscaPecas('un')">{{ buscaPecasOrdenarCampo==='un' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('un')" class="th-filtro-limpar" (click)="limparFiltroBusca('un', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'un'" id="filtro-busca-compra-un" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['un']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('un'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'estoque'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('estoque')" (click)="toggleFiltroBusca('estoque', $event)" [title]="temFiltroBusca('estoque') ? ('Filtro: ' + filtrosBusca['estoque']) : 'Clique para filtrar'">Estoque</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='estoque'" (click)="ordenarBuscaPecas('estoque')">{{ buscaPecasOrdenarCampo==='estoque' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('estoque')" class="th-filtro-limpar" (click)="limparFiltroBusca('estoque', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'estoque'" id="filtro-busca-compra-estoque" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['estoque']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('estoque'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'valorMoedaIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('valorMoedaIpi')" (click)="toggleFiltroBusca('valorMoedaIpi', $event)" [title]="temFiltroBusca('valorMoedaIpi') ? ('Filtro: ' + filtrosBusca['valorMoedaIpi']) : 'Clique para filtrar'">CUSTO U$</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='valorMoedaIpi'" (click)="ordenarBuscaPecas('valorMoedaIpi')">{{ buscaPecasOrdenarCampo==='valorMoedaIpi' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('valorMoedaIpi')" class="th-filtro-limpar" (click)="limparFiltroBusca('valorMoedaIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'valorMoedaIpi'" id="filtro-busca-compra-valorMoedaIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['valorMoedaIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('valorMoedaIpi'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'valorReaisIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('valorReaisIpi')" (click)="toggleFiltroBusca('valorReaisIpi', $event)" [title]="temFiltroBusca('valorReaisIpi') ? ('Filtro: ' + filtrosBusca['valorReaisIpi']) : 'Clique para filtrar'">CUSTO R$</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='valorReaisIpi'" (click)="ordenarBuscaPecas('valorReaisIpi')">{{ buscaPecasOrdenarCampo==='valorReaisIpi' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('valorReaisIpi')" class="th-filtro-limpar" (click)="limparFiltroBusca('valorReaisIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'valorReaisIpi'" id="filtro-busca-compra-valorReaisIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['valorReaisIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('valorReaisIpi'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'fabricante'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('fabricante')" (click)="toggleFiltroBusca('fabricante', $event)" [title]="temFiltroBusca('fabricante') ? ('Filtro: ' + filtrosBusca['fabricante']) : 'Clique para filtrar'">Fabricante</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='fabricante'" (click)="ordenarBuscaPecas('fabricante')">{{ buscaPecasOrdenarCampo==='fabricante' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('fabricante')" class="th-filtro-limpar" (click)="limparFiltroBusca('fabricante', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'fabricante'" id="filtro-busca-compra-fabricante" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['fabricante']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('fabricante'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th>Origem</th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'dataUltAtual'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('dataUltAtual')" (click)="toggleFiltroBusca('dataUltAtual', $event)" [title]="temFiltroBusca('dataUltAtual') ? ('Filtro: ' + filtrosBusca['dataUltAtual']) : 'Clique para filtrar'">Data Ult. Atual. Preço</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='dataUltAtual'" (click)="ordenarBuscaPecas('dataUltAtual')">{{ buscaPecasOrdenarCampo==='dataUltAtual' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('dataUltAtual')" class="th-filtro-limpar" (click)="limparFiltroBusca('dataUltAtual', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'dataUltAtual'" id="filtro-busca-compra-dataUltAtual" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['dataUltAtual']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('dataUltAtual'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'limiteDias'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('limiteDias')" (click)="toggleFiltroBusca('limiteDias', $event)" [title]="temFiltroBusca('limiteDias') ? ('Filtro: ' + filtrosBusca['limiteDias']) : 'Clique para filtrar'">Limite p/ Atual. (Dias)</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='limiteDias'" (click)="ordenarBuscaPecas('limiteDias')">{{ buscaPecasOrdenarCampo==='limiteDias' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('limiteDias')" class="th-filtro-limpar" (click)="limparFiltroBusca('limiteDias', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'limiteDias'" id="filtro-busca-compra-limiteDias" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['limiteDias']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('limiteDias'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'alternativo'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('alternativo')" (click)="toggleFiltroBusca('alternativo', $event)" [title]="temFiltroBusca('alternativo') ? ('Filtro: ' + filtrosBusca['alternativo']) : 'Clique para filtrar'">Alternativo</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='alternativo'" (click)="ordenarBuscaPecas('alternativo')">{{ buscaPecasOrdenarCampo==='alternativo' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('alternativo')" class="th-filtro-limpar" (click)="limparFiltroBusca('alternativo', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'alternativo'" id="filtro-busca-compra-alternativo" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['alternativo']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('alternativo'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'codigo'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('codigo')" (click)="toggleFiltroBusca('codigo', $event)" [title]="temFiltroBusca('codigo') ? ('Filtro: ' + filtrosBusca['codigo']) : 'Clique para filtrar'">Código</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='codigo'" (click)="ordenarBuscaPecas('codigo')">{{ buscaPecasOrdenarCampo==='codigo' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('codigo')" class="th-filtro-limpar" (click)="limparFiltroBusca('codigo', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'codigo'" id="filtro-busca-compra-codigo" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['codigo']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('codigo'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="buscaPecasResultadosExibidos.length === 0">
              <td colspan="13" class="busca-modal-empty">Nenhum resultado para os filtros de coluna aplicados.</td>
            </tr>
            <ng-container *ngFor="let p of buscaPecasResultadosExibidos">

              <!-- Linha do item principal -->
              <tr class="busca-pecas-linha"
                  [class.busca-pecas-linha-selecionada]="buscaPecasProdutoSelecionado === p"
                  [class.bp-sem-preco]="p.vlrVenda == null || p.vlrVenda <= 0"
                  [class.bp-preco-desatualizado]="p.precoDesatualizado && p.vlrVenda > 0"
                  (click)="selecionarProdutoParaDetalhe(p)"
                  (dblclick)="selecionarPecaModal(p)">
                <td class="bp-pn">{{ p.refforn ?? p.referencia ?? p.codprod }}</td>
                <td class="bp-cd">{{ p.condicao || '—' }}</td>
                <td class="bp-desc">{{ p.descricao }}</td>
                <td class="bp-un">{{ p.codvol ?? 'UN' }}</td>
                <td class="bp-estoque text-right" [class.estoque-zero]="(p.estoque ?? 0) <= 0">
                  {{ p.estoque != null ? (p.estoque | number: casasDecimaisQtd(p.codvol, p.estoque) :'pt-BR') : '—' }}
                </td>
                <td class="bp-preco text-right">{{ custoMoedaBusca(p, cotacaoValorNumerico) != null ? (custoMoedaBusca(p, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                <td class="bp-preco text-right">{{ custoReaisBusca(p) != null ? (custoReaisBusca(p) | number:'1.2-2':'pt-BR') : '—' }}</td>
                <td class="bp-marca">{{ p.marca || '—' }}</td>
                <td class="bp-origem">
                  <span *ngIf="false && p.origem" class="origem-badge" [class.origem-badge-nacional]="p.origemNacional">{{ p.origem }}</span>
                  <span>—</span>
                </td>
                <td class="bp-preco text-right">{{ p.dataUltAtualPreco || '—' }}</td>
                <td class="bp-preco text-right">{{ p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : '—' }}</td>
                <td class="bp-alt">{{ p.alternativo || '—' }}</td>
                <td class="bp-preco text-right">{{ p.codprod ?? '—' }}</td>
              </tr>

              <!-- Sub-lista de alternativos — permanece visível mesmo ao selecionar um dos
                   alternativos abaixo (por isso usa buscaPecasProdutoExpandido, não
                   buscaPecasProdutoSelecionado, que muda para o alternativo clicado). -->
              <ng-container *ngIf="buscaPecasProdutoExpandido === p">
                <ng-container *ngIf="!buscaPecasAlternativosCarregando && buscaPecasAlternativos.length > 0">
                  <tr>
                    <td colspan="13" class="bp-alt-faixa">
                      PRODUTOS ALTERNATIVOS
                      <span class="bp-alt-badge">{{ buscaPecasAlternativos.length }}</span>
                    </td>
                  </tr>
                  <tr *ngFor="let a of buscaPecasAlternativos"
                      class="busca-pecas-linha bp-alt-row"
                      [class.busca-pecas-linha-selecionada]="buscaPecasProdutoSelecionado === a"
                      [class.bp-sem-preco]="a.vlrVenda == null || a.vlrVenda <= 0"
                      (click)="selecionarAlternativoParaDetalhe(a)"
                      (dblclick)="selecionarPecaModal(a)">
                    <td class="bp-pn bp-alt-pn">
                      <span *ngIf="a.substituto === 'S'" class="busca-pecas-alt-subst" title="Substituto direto">★</span>
                      {{ a.refforn }}
                    </td>
                    <td class="bp-cd">{{ a.condicao || '—' }}</td>
                    <td class="bp-desc">{{ a.descricao }}</td>
                    <td class="bp-un">{{ a.codvol ?? 'UN' }}</td>
                    <td class="bp-estoque text-right" [class.estoque-zero]="!a.estoqueTotal || a.estoqueTotal === 0">
                      {{ a.estoqueTotal > 0 ? (a.estoqueTotal | number: casasDecimaisQtd(a.codvol, a.estoqueTotal) :'pt-BR') : '0' }}
                    </td>
                    <td class="bp-preco text-right">{{ custoMoedaBusca(a, cotacaoValorNumerico) != null ? (custoMoedaBusca(a, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                    <td class="bp-preco text-right">{{ custoReaisBusca(a) != null ? (custoReaisBusca(a) | number:'1.2-2':'pt-BR') : '—' }}</td>
                    <td class="bp-marca">{{ a.marca || '—' }}</td>
                    <td class="bp-origem">
                      <span *ngIf="false && a.origem" class="origem-badge" [class.origem-badge-nacional]="a.origemNacional">{{ a.origem }}</span>
                      <span>—</span>
                    </td>
                    <td class="bp-preco text-right">{{ a.dataUltAtualPreco || '—' }}</td>
                    <td class="bp-preco text-right">{{ a.limitePrazoAtualDias > 0 ? a.limitePrazoAtualDias : '—' }}</td>
                    <td class="bp-alt">{{ a.alternativo || '—' }}</td>
                    <td class="bp-preco text-right">{{ a.codprod ?? '—' }}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Painel de estoque por local + imagem -->
      <div *ngIf="buscaPecasProdutoSelecionado" class="pcf-bp-estoque-painel">
        <div class="pcf-bp-estoque-coluna">
          <div class="pcf-bp-estoque-titulo">
            Estoque por Local —
            <strong>{{ buscaPecasProdutoSelecionado.refforn ?? buscaPecasProdutoSelecionado.referencia }}
            {{ buscaPecasProdutoSelecionado.descricao }}</strong>
          </div>
          <div *ngIf="buscaPecasLocaisCarregando" style="padding:8px;color:#888;font-size:13px"><app-loading-indicator size="inline"></app-loading-indicator> Carregando estoque…</div>
          <div *ngIf="!buscaPecasLocaisCarregando && buscaPecasLocais.length === 0"
            style="padding:8px;color:#e53e3e;font-size:13px">Sem registros de estoque para esta peça.</div>
          <table *ngIf="!buscaPecasLocaisCarregando && buscaPecasLocais.length > 0" class="pcf-bp-estoque-tabela">
            <thead>
              <tr>
                <th class="bp-emp">Empresa</th>
                <th class="bp-local">Local</th>
                <th class="bp-num">Total</th>
                <th class="bp-num">Reservado</th>
                <th class="bp-num">Disponível</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of buscaPecasLocais"
                [style.background-color]="corLinhaEstoque(loc.codemp)"
                [class.bp-row-zero]="loc.disponivel <= 0">
                <td class="bp-emp">
                  <span class="bp-emp-cod">{{ loc.codemp }}</span>{{ loc.nomeEmp }}
                </td>
                <td class="bp-local">{{ loc.descrLocal }}</td>
                <td class="bp-num">{{ (loc.qtdTotal ?? 0) | number: casasDecimaisEstoqueLocal(loc.qtdTotal) :'pt-BR' }}</td>
                <td class="bp-num bp-reservado">{{ (loc.qtdReservada ?? 0) | number: casasDecimaisEstoqueLocal(loc.qtdReservada) :'pt-BR' }}</td>
                <td class="bp-num" [class.bp-disp-pos]="loc.disponivel > 0"
                  [class.bp-disp-zero]="loc.disponivel <= 0">
                  {{ loc.disponivel | number: casasDecimaisEstoqueLocal(loc.disponivel) :'pt-BR' }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bp-row-total">
                <td colspan="2">Total</td>
                <td class="bp-num">{{ buscaTotalLocais('qtdTotal') | number: casasDecimaisEstoqueLocal(buscaTotalLocais('qtdTotal')) :'pt-BR' }}</td>
                <td class="bp-num">{{ buscaTotalLocais('qtdReservada') | number: casasDecimaisEstoqueLocal(buscaTotalLocais('qtdReservada')) :'pt-BR' }}</td>
                <td class="bp-num">{{ buscaTotalLocais('disponivel') | number: casasDecimaisEstoqueLocal(buscaTotalLocais('disponivel')) :'pt-BR' }}</td>
              </tr>
            </tfoot>
          </table>
        </div><!-- /pcf-bp-estoque-coluna -->

        <!-- Imagem do produto selecionado — lado direito -->
        <div class="pcf-bp-imagem-coluna">
          <div *ngIf="buscaPecasImagemCarregando" class="pcf-bp-imagem-loading"><app-loading-indicator></app-loading-indicator> </div>
          <img *ngIf="!buscaPecasImagemCarregando && buscaPecasImagemUrl"
               [src]="buscaPecasImagemUrl"
               class="pcf-bp-imagem-produto"
               alt="Imagem do produto"
               title="Clique para ampliar"
               (click)="abrirPreviewImagemBusca()">
          <div *ngIf="!buscaPecasImagemCarregando && !buscaPecasImagemUrl" class="pcf-bp-imagem-vazia">
            Sem imagem cadastrada
          </div>
          <!-- Miniaturas — só aparece quando o produto tem mais de uma imagem cadastrada -->
          <div class="pcf-bp-imagem-miniaturas" *ngIf="!buscaPecasImagemCarregando && buscaPecasImagensExtras.length > 1">
            <img *ngFor="let img of buscaPecasImagensExtras; let i = index"
                 [src]="img"
                 class="pcf-bp-imagem-miniatura"
                 [class.ativa]="i === buscaPecasImagemIndexAtivo"
                 alt="Miniatura do produto"
                 (click)="selecionarImagemBusca(i)">
          </div>
        </div><!-- /pcf-bp-imagem-coluna -->
      </div>
    </div><!-- /modal-body -->
    <div class="pcf-modal-footer pcf-bp-footer-com-legenda">
      <!-- Legenda das cores de destaque da tabela -->
      <div class="itens-legenda pcf-bp-legenda-footer">
        <span class="legenda-item"><span class="legenda-dot legenda-dot-amarelo"></span>Sem Preço</span>
        <span class="legenda-item"><span class="legenda-dot legenda-dot-vermelho"></span>Preço Desatualizado</span>
      </div>
      <div class="pcf-bp-footer-botoes">
        <button type="button" class="pcf-modal-btn" (click)="fecharBuscaPecas()">Cancelar</button>
        <button type="button" class="pcf-modal-btn-primary"
          *ngIf="buscaPecasProdutoSelecionado" (click)="confirmarSelecaoPeca()">
          ✓ Usar esta peça
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ── Preview ampliado da imagem do produto (F7) ───────────────── -->
<div class="pcf-modal-overlay pcf-imagem-preview-overlay" *ngIf="imagemPreviewAberta"
     (click)="fecharPreviewImagemBusca()" (keydown.escape)="fecharPreviewImagemBusca()">
  <div class="pcf-imagem-preview-box" (click)="$event.stopPropagation()">
    <button type="button" class="pcf-imagem-preview-fechar" (click)="fecharPreviewImagemBusca()" title="Fechar">✕</button>
    <div class="pcf-imagem-preview-img-wrap">
      <img [src]="buscaPecasImagemUrl" class="pcf-imagem-preview-img" alt="Imagem do produto ampliada">
    </div>
    <!-- Miniaturas — só aparece quando o produto tem mais de uma imagem cadastrada -->
    <div class="pcf-imagem-preview-miniaturas" *ngIf="buscaPecasImagensExtras.length > 1">
      <img *ngFor="let img of buscaPecasImagensExtras; let i = index"
           [src]="img"
           class="pcf-imagem-preview-miniatura"
           [class.ativa]="i === buscaPecasImagemIndexAtivo"
           alt="Miniatura do produto"
           (click)="selecionarImagemBusca(i)">
    </div>
  </div>
</div>

<!-- Confirmação de saída (Voltar / menu lateral) -- nível principal, vale em qualquer aba -->
<div class="pcf-sair-overlay" *ngIf="confirmacaoSairAberta" (click)="cancelarSair()">
  <div class="pcf-sair-modal" (click)="$event.stopPropagation()">
    <div class="pcf-sair-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    </div>
    <h3 class="pcf-sair-titulo">Atenção!</h3>
    <p class="pcf-sair-msg">Deseja realmente sair da tela de COMPRA?</p>
    <div class="pcf-sair-footer">
      <button type="button" class="pcf-modal-btn" (click)="cancelarSair()">Cancelar</button>
      <button type="button" class="pcf-modal-btn-primary" style="background:#dc2626; border-color:#dc2626;" (click)="confirmarSair()">Sair mesmo assim</button>
    </div>
  </div>
</div>

